import { $prose } from '@milkdown/kit/utils';
import { Plugin, PluginKey } from '@milkdown/kit/prose/state';
import { Decoration, DecorationSet } from '@milkdown/kit/prose/view';

import { headingToSlug } from '../lib/headingSlug';

const headingIdPluginKey = new PluginKey('headingId');

/**
 * Milkdown plugin that adds id attributes to heading elements.
 * Enables anchor link navigation from TOC to headings in the editor.
 */
export const headingIdPlugin = $prose(() => {
  return new Plugin({
    key: headingIdPluginKey,
    props: {
      decorations(state) {
        const decorations: Decoration[] = [];
        const slugCounts: Record<string, number> = {};

        state.doc.descendants((node, pos) => {
          if (node.type.name === 'heading') {
            const text = node.textContent;
            const baseId = headingToSlug(text);
            const count = slugCounts[baseId] ?? 0;
            const id = count > 0 ? headingToSlug(text, count) : baseId;

            slugCounts[baseId] = count + 1;

            // Add a node decoration that sets the id attribute
            decorations.push(Decoration.node(pos, pos + node.nodeSize, { id }));
          }
        });

        return DecorationSet.create(state.doc, decorations);
      },
    },
  });
});
